<div class="mc-form-field" [ngClass]="fieldClasses">
  @if (label) {
    <label class="mc-form-field__label">{{ label }}</label>
  }
  <div class="mc-form-field__input">
    <ng-content></ng-content>
  </div>
</div>
